package one.healthium.ui.compose.components

import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import loco.GENERAL_CANCEL
import one.healthium.ui.compose.back_handler.LocalBackPressHandler
import org.jetbrains.compose.resources.stringResource

@Composable
actual fun AppSheetTopBar(
    title: @Composable () -> Unit,
    onCloseClicked: (() -> Unit)?,
    colors: TopAppBarColors?,
    actions: @Composable RowScope.() -> Unit,
) {
    val backPressHandler = LocalBackPressHandler.current
    val appBarColors = colors ?: AppTopBarDefaults.transparent
    AppTopBar(
        windowInsets = WindowInsets(0),
        title = title,
        colors = appBarColors,
        expandedHeight = 62.dp,
        navigationIcon = {
            AppTextButton(
                modifier = Modifier.padding(start = 4.dp).testTag("sheet_close"),
                onClick = {
                    onCloseClicked?.invoke() ?: backPressHandler?.onBackPressed()
                }
            ) {
                Text(
                    text = stringResource(loco.Res.string.GENERAL_CANCEL),
                    color = appBarColors.navigationIconContentColor,
                )
            }
        },
        actions = actions,
    )
}